export const SYSTEM_MODULES = [
  ['hoje', 'Hoje', 'Prioridades e operação diária'],
  ['dashboard', 'Dashboard', 'Indicadores e visão geral'],
  ['produtividade', 'Produtividade', 'Caixa de entrada, vistas e atalhos'],
  ['chamados', 'Chamados', 'Abertura, atendimento e histórico'],
  ['rotinas', 'Rotinas', 'Rotinas preventivas'],
  ['gestao', 'Gestão', 'Relatórios e gestão operacional'],
  ['agenda', 'Agenda', 'Compromissos e capacidade'],
  ['clientes', 'Clientes', 'Clientes, contratos e cadastros'],
  ['senhas', 'Banco de senhas', 'Credenciais protegidas dos clientes'],
  ['financeiro', 'Financeiro', 'Fechamentos, faturas e pagamentos'],
  ['crm', 'CRM', 'Leads, oportunidades e orçamentos'],
  ['produtos_estoque', 'Produtos e estoque', 'Catálogo, planos, módulos, compras e movimentações'],
  ['pessoas', 'Pessoas e deslocamentos', 'Frequência, quilometragem e acertos'],
  ['configuracoes', 'Configurações', 'Configurações gerais do sistema'],
  ['usuarios', 'Usuários', 'Contas e permissões'],
  ['auditoria', 'Auditoria', 'Logs e rastreabilidade'],
  ['saude', 'Saúde operacional', 'Diagnósticos técnicos do sistema'],
]

export const ROLE_MODULES = {
  admin: SYSTEM_MODULES.map(([id]) => id),
  tecnico: ['hoje', 'dashboard', 'produtividade', 'chamados', 'rotinas', 'gestao', 'agenda', 'senhas'],
  financeiro: ['dashboard', 'produtividade', 'financeiro', 'crm'],
}

export const modulesForUser = user => {
  if (user?.role === 'cliente') return []
  const modules = Array.isArray(user?.modulos_permitidos) ? user.modulos_permitidos : ROLE_MODULES[user?.role] || []
  if (user?.role !== 'tecnico') return modules
  const withoutPeople = modules.filter(module => module !== 'pessoas')
  return user?.bate_ponto ? [...withoutPeople, 'pessoas'] : withoutPeople
}

export const userHasModule = (user, module) => {
  if (user?.role === 'cliente') return ['dashboard','chamados'].includes(module)
  const modules = modulesForUser(user)
  // Compatibilidade de transição: quem já recebeu CRM mantém o catálogo até
  // que a permissão Produtos e estoque seja revisada no cadastro do usuário.
  if (module === 'produtos_estoque') return modules.includes(module) || modules.includes('crm')
  return modules.includes(module)
}
